import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-view-library',
  templateUrl: './view-library.component.html',
  styleUrls: ['./view-library.component.css']
})
export class ViewLibraryComponent implements OnInit {
  libraryList: any;
  libraryId: any;

  constructor(public mainService: MainService, private activatedroute: ActivatedRoute) { }

  ngOnInit() {
    this.activatedroute.params.subscribe((res) => {
      this.libraryId = res.id;
    })
    this.getLibraryList()
  }

// getLibraryList by id
  getLibraryList() {
    this.mainService.showSpinner();
    this.mainService.getApi(ApiUrls.library_view+`?libraryId=${this.libraryId}`, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.libraryList = res.result;
        this.mainService.hideSpinner();
      } else {
        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }

}
